module.exports = __webpack_public_path__ + "media/dashboard/assets/images/inbox_icons/facebook-badge-nocolor-5eb01d6733c74bebf57c263b14210c78.svg";